import { authApiCall } from '../auth/saga';

export const sendNotification = data =>
  authApiCall({
    url: '/users/send-notification/',
    method: 'post',
    data,
  });